export const AT_USER = {
    USER_UPDATE_CURRENT: '[USER] CURRENT UPDATED',
};

export const AT_LOGIN = {
    LOGIN_SUCCESS: '[LOGIN] LOGIN SUCCESS',
    LOGIN_ERROR  : '[LOGIN] LOGIN ERROR',
    LOGIN_LOGOUT : '[LOGIN] LOGIN LOGOUT',
};